module.exports = __webpack_public_path__ + "img/vital.1cee2c1a.svg";